import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as d3 from 'd3'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'

import Button from '../../components/Button/Button.js'
import Checkbox from '../../components/Checkbox/Checkbox.js'

import { pmUpdateFromHybrid, showTooltip, hideTooltip, setJDISettingsModalOpen } from '../../actions/actions.export.js';
import convertLineToRow from '../../pattern_utilities/convertLineToRow.js';
import roundValue from '../../pattern_utilities/roundValue.js';
import checkLineIntersection from '../../pattern_utilities/checkLineIntersection.js';


import canI from '../../canI.js';

import './JustDrawIt.css';


var drawJDITimeout;

class JustDrawIt extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      currentLines: [],
      lineSegments: props.pattern.lineSegments || [],
      splineInProgress: [],
      lineInProgress: {},
      coordinateInFocus: 'x',
      midLine: false,
      lostRows: 0
    }
    this.drawSVG = this.drawSVG.bind(this);
    this.handleChangeParam = this.handleChangeParam.bind(this);
    this.keyListener = this.keyListener.bind(this);
  }

  handleChangeParam(param, v){
    const { dispatch, patternManager, cacheID } = this.props;  

    var updated_data = {};
    updated_data[param] = parseFloat(v);

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: updated_data
    }))
    
    setTimeout((e)=>{
      this.generate(patternManager.cache[cacheID].lineSegments);  
    })
  }

  drawSVG(){    
    const { dispatch, globalReducer, patternManager, cacheID, tool, pattern, user, team } = this.props;  

    const jdiSettings = patternManager.cache[cacheID].jdiSettings;

    // console.log("DRAW", patternManager.cache[cacheID]);

    var that = this;

    var lineSegments = this.state.lineSegments || [];
    var currentLines = this.state.currentLines || [];

    var el = document.getElementById('jdi-svg');
    if(!el) return;
    var positionInfo = el.getBoundingClientRect();
    var width = positionInfo.width;
    var height = positionInfo.height;

    var svg = d3.select('#jdi-svg')
      .attr('width', width)
      .attr('height', height)
      ;

    // we tuck this in a G so we can easily clear it
    svg.selectAll('g').remove();
    svg = svg.append('g');

    var padding = 20;
    var paneRatio = (width - padding * 2) / (height - padding * 2);
    var drawRatio = jdiSettings.canvas_width / jdiSettings.canvas_height;

    if(paneRatio > drawRatio){
      var rectHeight = height - padding * 2;
      var rectWidth = rectHeight * drawRatio;
    } else {
      var rectWidth = width - padding * 2;
      var rectHeight = rectWidth / drawRatio;
    }

    var draggingEndpoint;
    var draggingSelection;
    var multiSelectDrag = {};
    var circleInProgress = false;
    var trimLine = {};

    svg.append('rect')
      .attr('x',0)
      .attr('y',0)
      .attr('width', width)
      .attr('height', height)
      .attr('fill', 'transparent')
      .on('mouseup', function(){
        handleDragTrimStop(this);
        handleDragBoxStop(this);
        handleDragEndpointStop(this);

        handleDrawCircleStop(this);
        handleDrawSplineStop(this);
      })
      .on('mousedown', function(){
        handleDragTrimStart(this);
        handleDragBoxStart(this);

        handleDrawCircleStart(this);
        handleDrawSplineStart(this);
      })
      .on('mousemove', function(){
        handleCrosshairsUpdate(this);

        handleDragTrimUpdate(this);
        handleDragBoxUpdate(this);
        handleDragEndpointUpdate(this);
        
        handleDrawSplineUpdate(this);
        handleDrawCircleUpdate(this);
        handleDrawLineUpdate(this);
      })
      .on('click', function(){
        handleDrawLineClick(this);
        handleDeselectClick();
      })
      ;

    svg.append('rect')
      .attr('x', width/2 - rectWidth/2)
      .attr('y', height/2 - rectHeight/2)
      .attr('width', rectWidth)
      .attr('height', rectHeight)
      .attr('class', 'jdi-svg-boundary')
      .attr('id', 'jdi-svg-boundary')
      .style('cursor', (tool === 'Pen' || tool === 'Continuous Pen' || tool === 'Spline') ? 'crosshair' : 'auto')
      .on('mouseout', function(){
        handleCrosshairsHide(this);
      })
      .on('mouseenter', function(){
        handleCrosshairsShow(this);
      })
      .on('mouseup', function(){
        handleDragTrimStop(this);
        handleDragEndpointStop(this);
        handleDragBoxStop(this);

        handleDrawCircleStop(this);
        handleDrawSplineStop(this);

      })
      .on('mousedown', function(){
        handleDragTrimStart(this);
        handleDragBoxStart(this);

        handleDrawCircleStart(this);
        handleDrawSplineStart(this);
      })
      .on('mousemove', function(){
        handleCrosshairsUpdate(this);

        handleDragTrimUpdate(this);
        handleDragEndpointUpdate(this);
        handleDragBoxUpdate(this);
        handleMultiSelectDragMove(this);
        
        handleDrawCircleUpdate(this);
        handleDrawSplineUpdate(this);
        handleDrawLineUpdate(this);
      })
      .on('click', function(){
        handleDrawLineClick(this);
        handleDeselectClick();
      })
      ;

    var tick_size = 10;

    var left_tick = svg.append('line')
      .attr('x1', width/2 - rectWidth/2)
      .attr('y1', height/2)
      .attr('x2', width/2 - rectWidth/2 + tick_size)
      .attr('y2', height/2)
      .attr('class', 'jdi-svg-boundary-tick')
      ;

    var right_tick = svg.append('line')
      .attr('x1', width/2 + rectWidth/2)
      .attr('y1', height/2)
      .attr('x2', width/2 + rectWidth/2 - tick_size)
      .attr('y2', height/2)
      .attr('class', 'jdi-svg-boundary-tick')
      ;

    var top_tick = svg.append('line')
      .attr('x1', width/2)
      .attr('y1', height/2 - rectHeight/2)
      .attr('x2', width/2)
      .attr('y2', height/2 - rectHeight/2 + tick_size)
      .attr('class', 'jdi-svg-boundary-tick')
      ;

    var bottom_tick = svg.append('line')
      .attr('x1', width/2)
      .attr('y1', height/2 + rectHeight/2)
      .attr('x2', width/2)
      .attr('y2', height/2 + rectHeight/2 - tick_size)
      .attr('class', 'jdi-svg-boundary-tick')
      ;


    var grid_lines_svg = svg.append('g');

    var lineInProgress = svg.append('line')
      .attr('id', 'line-in-progress')
      ;

    svg.append('line')
      .attr('id', 'jdi-trim-line')
      .attr('opacity', 0)
      ;

    svg.append('circle')
      .attr('id', 'jdi-snap-circle')
      .attr('opacity', 0)
      .attr('r', 5)
      ;

    svg.append('line')
      .attr('id', 'jdi-snap-vertical-ruler')
      .attr('class', 'jdi-snap-ruler')
      .attr('opacity', 0)
      ;

    svg.append('line')
      .attr('id', 'jdi-snap-horizontal-ruler')
      .attr('class', 'jdi-snap-ruler')
      .attr('opacity', 0)
      ;

    svg.append('text')
      .attr('id', 'jdi-snap-vertical-ruler-label')
      .attr('class', 'jdi-snap-ruler-label')
      .attr('text-anchor', 'start')
      .attr('opacity', 0)
      ;

    svg.append('text')
      .attr('id', 'jdi-snap-horizontal-ruler-label')
      .attr('class', 'jdi-snap-ruler-label')
      .attr('text-anchor', 'start')
      .attr('opacity', 0)
      ;

    svg.append('text')
      .attr('id', 'jdi-selected-line-count-label')
      .attr('x', width/2 - rectWidth/2)
      .attr('y', height/2 + rectHeight/2 + 15)
      .text((d)=>{
        if(currentLines.length > 1){
          return currentLines.length + ' lines selected'; 
        }
        if(currentLines.length === 1){
          return currentLines.length + ' line selected'; 
        }
        return;
      })
      ;

    // console.log(this.state.lostRows);
    svg.append('text')
      .attr('id', 'jdi-selected-line-count-label')
      .attr('x', width/2 - rectWidth/2)
      .attr('y', height/2 - rectHeight/2 - 5)
      .text((d)=>{
        if(this.state.lostRows > 0){
          return this.state.lostRows + ' line' + (this.state.lostRows > 1 ? 's' : '') + ' couldn\'t be converted by Auto Fix.'; 
        }
        return;
      })


    var x_scale = d3.scaleLinear()
      .domain([0,jdiSettings.canvas_width])
      .range([width/2 - rectWidth/2, width/2 + rectWidth/2])
      ;

    var y_scale = d3.scaleLinear()
      .domain([jdiSettings.canvas_height, 0])
      .range([height/2 - rectHeight/2, height/2 + rectHeight/2])
      ;

    if(this.state.midLine){
      lineInProgress
        .attr('x1', x_scale(this.state.lineInProgress.x1) )
        .attr('y1', y_scale(this.state.lineInProgress.y1) )
        .attr('x2', x_scale(this.state.lineInProgress.x1) )
        .attr('y2', y_scale(this.state.lineInProgress.y1) )
        .attr('class', function(d){
          if(!globalReducer.colors) return;
          if(pattern.rows.length === 0) return 'line_0';
          return 'line_' + (((pattern.rows[pattern.rows.length - 1].original_index + 1) * 3) % 11);
        })
        ;
    }

    if(jdiSettings.grid_snap_show && jdiSettings.grid_snap_global){
      
      for(var x = 0; x < jdiSettings.canvas_width; x += jdiSettings.grid_snap_size){
        grid_lines_svg.append('line')
          .attr('x1', x_scale(x))
          .attr('y1', y_scale(0))
          .attr('x2', x_scale(x))
          .attr('y2', y_scale(jdiSettings.canvas_height))
          .attr('class', 'jdi-grid-line')
          ;
      }

      for(var y = 0; y < jdiSettings.canvas_height; y += jdiSettings.grid_snap_size){
        grid_lines_svg.append('line')
          .attr('x1', x_scale(0))
          .attr('y1', y_scale(y))
          .attr('x2', x_scale(jdiSettings.canvas_width))
          .attr('y2', y_scale(y))
          .attr('class', 'jdi-grid-line')
          ;
      }
    }

    var line_svg = svg.selectAll('.jdi-svg-line')
      .data(lineSegments)
      .enter()
      ;

    line_svg.append('line')
        .attr('id', function(d, i){ return 'jdi-line-' + i; })
        .attr('x1', function(d){ return x_scale(d.x1); })
        .attr('y1', function(d){ return y_scale(d.y1); })
        .attr('x2', function(d){ return x_scale(d.x2); })
        .attr('y2', function(d){ return y_scale(d.y2); })
        .attr('class', (d, i, j)=>{
          var c = 'jdi-svg-line'

          i = parseInt(i);

          if(tool === 'Pointer' || tool === 'Trim'){
            if(!draggingEndpoint){
              c += ' jdi-svg-line-selectable';
            }
            if(currentLines.indexOf(i) > -1){ 
              c += ' jdi-svg-line-selected';
            } else if(currentLines.length){
              c += ' jdi-svg-line-selected-not';
            }
          }

          if(pattern.rows[i]){
            if(globalReducer.errors && pattern.rows[i].errors){
              if(pattern.rows[i].errors.length > 0){
                c += ' line_error';
              }
            }
            if(globalReducer.colors && !pattern.rows[i].greyscale){
              // console.log('l_color', pattern.rows[i]);
              c += ' line_' + ((pattern.rows[i].original_index * 3) % 11);    
            }
            if(pattern.rows[i].bold){
              c += ' jdi-svg-line-bold';    
            }
            if(pattern.rows[i].invisible){
              c += ' jdi-svg-line-invisible';
            }
          }

          return c;
        })
        .on('click', (d, i, j) => {
          var d = d3.select(this);

          if(tool === 'Pointer'){
            this.setState({
              currentLines: [parseInt(i)]
            })
            this.drawSVG();
          }

          if(tool === 'Trim'){
            handleTrimLine(this, parseInt(i));
          }
        })
        .each((d,i,j) => {
          if(tool === 'Pointer' && currentLines.indexOf(i) > -1 && currentLines.length === 1){ 
            var start_selector = svg.append('circle')
              .attr('id', 'jdi-selection-handle-' + i + '-1')
              .attr('cx', x_scale(d.x1))
              .attr('cy', y_scale(d.y1))
              .attr('class', 'jdi-selection-handle ' + (pattern.lineSegments.length > canI(user, team, 'jdi_line_limit', team.current) ? 'jdi-selection-handle-locked' : ''))
              .attr('r', 5)
              .on('mousedown', () => {
                draggingEndpoint = {
                  index: i,
                  which: 1,
                  ogx: d.x1,
                  ogy: d.y1,
                  lineInProgress: {
                    x1: d.x2,
                    y1: d.y2
                  }
                };

                d3.selectAll('.jdi-svg-line')
                  .style('pointer-events', 'none')
                  ;
                d3.select('#jdi-svg-boundary')
                  .style('cursor', 'grabbing')
                  ;
              })
              .on('mouseup', () => {

              })
              ;
            var end_selector = svg.append('circle')
              .attr('id', 'jdi-selection-handle-' + i + '-2')
              .attr('cx', x_scale(d.x2))
              .attr('cy', y_scale(d.y2))
              .attr('class', 'jdi-selection-handle ' + (pattern.lineSegments.length > canI(user, team, 'jdi_line_limit', team.current) ? 'jdi-selection-handle-locked' : ''))
              .attr('r', 5)
              .on('mousedown', () => {
                draggingEndpoint = {
                  index: i,
                  which: 2,
                  ogx: d.x2,
                  ogy: d.y2,
                  lineInProgress: {
                    x1: d.x1,
                    y1: d.y1
                  }
                };
                d3.selectAll('.jdi-svg-line')
                  .style('pointer-events', 'none')
                  ;
                d3.select('#jdi-svg-boundary')
                  .style('cursor', 'grabbing')
                  ;
              })
              .on('mouseup', () => {
                 draggingEndpoint = false;
              })
              ;
          }
        })
        ;


    if(currentLines.length > 1){

      var min_x = jdiSettings.canvas_width;
      var min_y = jdiSettings.canvas_height;
      // console.log(min_x, min_y);
      var max_x = 0;
      var max_y = 0;

      for(var i in currentLines){
        var l = lineSegments[currentLines[i]];
        if(l.x1 < min_x) min_x = l.x1;
        if(l.y1 < min_y) min_y = l.y1;
        if(l.x2 < min_x) min_x = l.x2;
        if(l.y2 < min_y) min_y = l.y2;

        if(l.x1 > max_x) max_x = l.x1;
        if(l.y1 > max_y) max_y = l.y1;
        if(l.x2 > max_x) max_x = l.x2;
        if(l.y2 > max_y) max_y = l.y2;
      }

      multiSelectDrag.min_x = min_x;
      multiSelectDrag.min_y = min_y;
      multiSelectDrag.max_x = max_x;
      multiSelectDrag.max_y = max_y;

      var multiselect = svg.append('rect')
        .attr('x', x_scale(min_x))
        .attr('y', y_scale(max_y))
        .attr('width', x_scale(max_x) - x_scale(min_x))
        .attr('height', y_scale(min_y) - y_scale(max_y))
        .attr('id', 'multi-select-rect')
        .on('mousedown', function(){
          handleMultiSelectDragStart(this);
        })
        .on('mousemove', function(){
          handleMultiSelectDragMove(this);
        })
        .on('mouseup', function(){
          handleMultiSelectDragStop(this);
        })
        ;

    }

    // var circleInProgressSVG = svg.append('circle')
    //   .attr('id', 'jdi-circle-in-progress')
    //   .attr('opacity', 0)
    //   .attr('r', 0)
    //   ;

    var polygonProgressSVG = svg.append('g');


    var splineInProgressSVG = svg.selectAll('.jdi-svg-spline-temp')
      .data(this.state.splineInProgress)
      .enter()
      ;

    splineInProgressSVG.append('line')
      .attr('x1', function(d){ return x_scale(d.x1); })
      .attr('y1', function(d){ return y_scale(d.y1); })
      .attr('x2', function(d){ return x_scale(d.x2); })
      .attr('y2', function(d){ return y_scale(d.y2); })
      .attr('stroke', '#aaa')
      .attr('stroke-width', 2)
      .style('pointer-events','none')
      .attr('class', function(d,i){
        if(!globalReducer.colors) return;
        if(pattern.rows.length === 0) return 'line_' +  ((i * 3) % 11);
        return 'line_' + ((pattern.rows[pattern.rows.length - 1].original_index + 1 + i) * 3) % 11;
      })
      ;


    svg.append('rect')
      .attr('id', 'jdi-selection-drag')
      .attr('opacity', 0)
      ;


    const handleTrimLine = (el, index, x, y, line_to_cut, haltGenerate) => {
      if(tool === 'Trim'){
        multiSelectDrag = {};
        let m;

        if(el){
          m = getCoordinates(d3.select('#jdi-svg-boundary'), false, tool);
        } else {
          m = [x, y];
        }

        let ls = lineSegments; //JSON.parse(JSON.stringify(lineSegments));
        let l;
        if(index !== undefined){
          l = ls[index];
        } else {
          for(var i in ls){
            if(ls[i].x1 === line_to_cut.x1 && ls[i].y1 === line_to_cut.y1 && ls[i].x2 === line_to_cut.x2 && ls[i].y2 === line_to_cut.y2){
              l = ls[i];
              index = i;
              break;
            }
          }
        }

        // console.log('cutting', index, 'at', x,y);

        // preload intersections with end coordinates
        let intersections = [
          {
            x: l.x1,
            y: l.y1
          },
          {
            x: l.x2,
            y: l.y2
          }
        ];

        for(let j = 0; j < ls.length; j++){
          if(j == i) continue;

          let l_test = ls[j];
          let intersection = getIntersection(l.x1,l.y1, l.x2,l.y2, l_test.x1,l_test.y1, l_test.x2,l_test.y2);

          if(intersection){
            if(intersection.x === l.x1 && intersection.y === l.y1){
              continue;
            }
            if(intersection.x === l.x2 && intersection.y === l.y2){
              continue;
            }
            intersections.push(intersection);
          }
        }

        // if we didnt add any, then bail here - nothing to trim
        // console.log("INTERSECT", intersections);
        if(intersections.length === 2) return;

        for(let j in intersections){
          intersections[j].distance = getDistance(m[0], m[1], intersections[j].x, intersections[j].y)
          intersections[j].angle = Math.atan2(m[1] - intersections[j].y, m[0] - intersections[j].x);
        }

        // sort by closest distance to where we clicked
        intersections.sort((a, b)=>{
          if(a.distance < b.distance) return -1;
          if(a.distance > b.distance) return 1;
          return 0;
        })

        // dedupe based on the direction, we need the closet on either side of our click - not just the two closest
        let variability = Math.PI/2;
        for(let j = 0; j < intersections.length - 1; j++){

          if(Math.abs(intersections[j].angle - intersections[j+1].angle) < variability){
            intersections.splice(j+1, 1);
            j--;
          }
        }

        // at this point we may have more than 2 but we only care about the first 2
        intersections = intersections.splice(0, 2);

        // figure out which is closest to our current line's end points so we can turn this one line into two new lines
        for(let j in intersections){
          intersections[j].distance_to_start = getDistance(l.x1, l.y1, intersections[j].x, intersections[j].y);
        }

        // sort by closest distance to the start of the OG line
        intersections.sort((a, b)=>{
          if(a.distance_to_start < b.distance_to_start) return -1;
          if(a.distance_to_start > b.distance_to_start) return 1;
          return 0;
        })

        // delete our old line
        ls.splice(index, 1);

        if(l.x1 !== intersections[0].x || l.y1 !== intersections[0].y){
          ls.push({
            x1: l.x1,
            y1: l.y1,
            x2: intersections[0].x,
            y2: intersections[0].y
          })
        }
        if(l.x2 !== intersections[1].x || l.y2 !== intersections[1].y){
          ls.push({
            x1: l.x2,
            y1: l.y2,
            x2: intersections[1].x,
            y2: intersections[1].y
          })
        }

        // console.log("CUT COMPLETE", ls);

        if(!haltGenerate){
          // generate lines with recolor=true
          this.generate(ls, false, true);
        }

        return true;
      }
    }


    const handleMultiSelectDragStart = (el) => {
      if(tool === 'Pointer' && pattern.lineSegments.length <= canI(user, team, 'jdi_line_limit', team.current)){
        multiSelectDrag = {};
        var m = getCoordinates(d3.select(el), false, tool);
        
        multiSelectDrag.x1 = m[0];
        multiSelectDrag.y1 = m[1];
      }
    }

    const handleMultiSelectDragMove = (el) => {
      if(multiSelectDrag.x1 && multiSelectDrag.y1 && pattern.lineSegments.length <= canI(user, team, 'jdi_line_limit', team.current)){
        if(tool === 'Pointer'){
          var m = getCoordinates(d3.select(el), false);
          // console.log(m);

          var dx = m[0] - multiSelectDrag.x1;
          var dy = m[1] - multiSelectDrag.y1;

          svg.select('#multi-select-rect')
            .attr('x', x_scale(min_x + dx))
            .attr('y', y_scale(max_y + dy))
            .attr('width', x_scale(max_x + dx) - x_scale(min_x + dx))
            .attr('height', y_scale(min_y + dy) - y_scale(max_y + dy))
            ;

          for(var i in currentLines){
            var l = lineSegments[currentLines[i]];
            svg.select('#jdi-line-' + currentLines[i])
              .attr('x1', x_scale(l.x1 + dx))
              .attr('y1', y_scale(l.y1 + dy))
              .attr('x2', x_scale(l.x2 + dx))
              .attr('y2', y_scale(l.y2 + dy))
              ;
          }
        }
      }
    }

    const handleMultiSelectDragStop = (el) => {
      if(tool === 'Pointer' && pattern.lineSegments.length <= canI(user, team, 'jdi_line_limit', team.current)){
        var m = getCoordinates(d3.select(el), false, tool);

        var dx = m[0] - multiSelectDrag.x1;
        var dy = m[1] - multiSelectDrag.y1;

        var ls = JSON.parse(JSON.stringify(lineSegments));
        
        for(var i in currentLines){
          var l = ls[currentLines[i]];
          l.x1 += dx;
          l.y1 += dy;
          l.x2 += dx;
          l.y2 += dy;
        }

        this.generate(ls);
        multiSelectDrag = {};
      }
    }


    const handleDragBoxStart = (el) => {
      if(tool === 'Pointer'){
        draggingSelection = {};
        var m = getCoordinates(d3.select(el), this.state.lineInProgress, tool);

        draggingSelection.x1 = m[0];
        draggingSelection.y1 = m[1];
        draggingSelection.xog = m[0];
        draggingSelection.yog = m[1];

        d3.select('#jdi-selection-drag')
          .attr('x', x_scale(draggingSelection.x1))
          .attr('y', y_scale(draggingSelection.y1))
          .attr('width', 0)
          .attr('height', 0)
          .attr('opacity', .5)
          ;

        d3.selectAll('.jdi-svg-line')
          .style('pointer-events', 'none')
          ;
      }
    }


    const handleDragTrimStart = (el) => {
      if(tool === 'Trim'){
        trimLine = {
          inProgress: true
        };
        let m = getCoordinates(d3.select(el), trimLine, tool);

        trimLine.x1 = m[0];
        trimLine.y1 = m[1];
        trimLine.x2 = m[0];
        trimLine.y2 = m[1];

        d3.select('#jdi-trim-line')
          .attr('x1', x_scale(trimLine.x1))
          .attr('y1', y_scale(trimLine.y1))
          .attr('x2', x_scale(trimLine.x2))
          .attr('y2', y_scale(trimLine.y2))
          .attr('opacity', .5)
          ;
      }
    }


    const handleDragTrimUpdate = (el) => {
      if(tool === 'Trim' && trimLine.inProgress){
        let m = getCoordinates(d3.select(el), trimLine, tool);
        trimLine.x2 = m[0];
        trimLine.y2 = m[1];

        d3.select('#jdi-trim-line')
          .attr('x1', x_scale(trimLine.x1))
          .attr('y1', y_scale(trimLine.y1))
          .attr('x2', x_scale(trimLine.x2))
          .attr('y2', y_scale(trimLine.y2))
          .attr('opacity', .5)
          ;
      }
    }

    const handleDragTrimStop = (el) => {
      if(tool === 'Trim'){
        
        let intersections = getIntersection
        let ls = lineSegments;
        let didTrim = false;

        for(let j = 0; j < ls.length; j++){

          let l_test = ls[j];
          let intersection = getIntersection(trimLine.x1,trimLine.y1, trimLine.x2,trimLine.y2, l_test.x1,l_test.y1, l_test.x2,l_test.y2);
          // console.log(intersection);
          if(intersection){
            // call this with manually passed coordinate and data to look up line index as it may change
            let didThisTrim = handleTrimLine(undefined, undefined, intersection.x, intersection.y, l_test);
            if(didThisTrim){
              didTrim = true;
              j--;
            }
          }
        }

        if(didTrim){
          this.generate(lineSegments);
        }

        trimLine = {}

        d3.select('#jdi-trim-line')
          .attr('opacity', 0)
          ;
      }
    }


    const handleDrawCircleStart = (el) => {
      if(tool === 'Circle' && pattern.lineSegments.length < canI(user, team, 'jdi_line_limit', team.current)){
        var m = getCoordinates(d3.select(el), this.state.lineInProgress, tool);
        circleInProgress = {};
        circleInProgress.x = m[0];
        circleInProgress.y = m[1];
      }
    }

    const handleDrawCircleUpdate = (el) => {
      if(tool === 'Circle' && circleInProgress && pattern.lineSegments.length < canI(user, team, 'jdi_line_limit', team.current)){
        var m = getCoordinates(d3.select(el), {x1: circleInProgress.x, y1: circleInProgress.y}, tool);
        
        circleInProgress.r_scaled = Math.sqrt( (Math.pow(x_scale(circleInProgress.x) - x_scale(m[0]), 2)) + (Math.pow(y_scale(circleInProgress.y) - y_scale(m[1]), 2)));;
        circleInProgress.r = Math.sqrt( (Math.pow(circleInProgress.x - m[0], 2)) + (Math.pow(circleInProgress.y - m[1], 2)));

        let rotate = Math.atan2(circleInProgress.y - m[1], circleInProgress.x - m[0]) + (Math.PI * jdiSettings.polygon_rotation / 180 )

        polygonProgressSVG.selectAll('.polygon-progress-line').remove();

        if(!jdiSettings.polygon_facets || jdiSettings.polygon_facets < 3) jdiSettings.polygon_facets = 3;

        for(let i = 0; i < Math.PI * 2; i += Math.PI * 2 / jdiSettings.polygon_facets){
          
          let ti = i + Math.PI + rotate;
          let tj = ti + (Math.PI * 2 / jdiSettings.polygon_facets);

          polygonProgressSVG.append('line')
            .attr('class', 'polygon-progress-line')
            .attr('x1', x_scale(circleInProgress.r * Math.cos(ti) + circleInProgress.x))
            .attr('y1', y_scale(circleInProgress.r * Math.sin(ti) + circleInProgress.y))
            .attr('x2', x_scale(circleInProgress.r * Math.cos(tj) + circleInProgress.x))
            .attr('y2', y_scale(circleInProgress.r * Math.sin(tj) + circleInProgress.y))
            .attr('stroke', '#888')
            .attr('stroke-width', 1)
            ;
        }
      }
    }


    const handleDrawCircleStop = (el) => {
      if(tool === 'Circle' && circleInProgress && pattern.lineSegments.length < canI(user, team, 'jdi_line_limit', team.current)){
        if(circleInProgress.r && circleInProgress.r > 0){
          var new_lines = JSON.parse(JSON.stringify(lineSegments));

          var m = getCoordinates(d3.select(el), {x1: circleInProgress.x, y1: circleInProgress.y}, tool);
          let rotate = Math.atan2(circleInProgress.y - m[1], circleInProgress.x - m[0]) + (Math.PI * jdiSettings.polygon_rotation / 180 )

          polygonProgressSVG.selectAll('.polygon-progress-line').remove();

          for(let i = 0; i < Math.PI * 2; i += Math.PI * 2 / jdiSettings.polygon_facets){
            
            let ti = i + Math.PI + rotate;
            let tj = ti + (Math.PI * 2 / jdiSettings.polygon_facets);

            new_lines.push({
              x1: circleInProgress.r * Math.cos(ti) + circleInProgress.x,
              y1: circleInProgress.r * Math.sin(ti) + circleInProgress.y,
              x2: circleInProgress.r * Math.cos(tj) + circleInProgress.x,
              y2: circleInProgress.r * Math.sin(tj) + circleInProgress.y,
            });
          }

          this.generate(new_lines);
        }


        d3.select('#jdi-circle-in-progress')
          .attr('opacity', 0)
          ;
        circleInProgress = false;
      }
    }


    const handleDrawSplineStart = (el) => {
      if(tool === 'Spline'){
        var m = getCoordinates(d3.select(el), this.state.lineInProgress, tool);
        
        this.setState({
          splineInProgress: [
            {
              x1: m[0],
              y1: m[1],
              x2: m[0],
              y2: m[1]
            }
          ]
        })
      }
    }

    const handleDrawSplineUpdate = (el) => {
      if(tool === 'Spline' && this.state.splineInProgress.length > 0 && pattern.lineSegments.length < canI(user, team, 'jdi_line_limit', team.current)){       
        var m = getCoordinates(d3.select(el), this.state.lineInProgress, tool);
        
        var last = this.state.splineInProgress[this.state.splineInProgress.length - 1];

        var distance = Math.sqrt( (Math.pow(last.x2 - m[0], 2)) + (Math.pow(last.y2 - m[1], 2)));

        if(distance > jdiSettings.canvas_width / 100){
          var splineInProgress = this.state.splineInProgress;

          // update last point's 2nd coordinate
          splineInProgress[splineInProgress.length - 1].x2 = m[0];
          splineInProgress[splineInProgress.length - 1].y2 = m[1];

          // create new point
          splineInProgress.push({
            x1: m[0],
            y1: m[1],
            x2: m[0],
            y2: m[1]
          });

          this.setState({
            splineInProgress: splineInProgress
          })

          this.drawSVG();
        }
      }
    }

    const handleDrawSplineStop = (el) => {
      if(tool === 'Spline' && this.state.splineInProgress.length > 0 && pattern.lineSegments.length < canI(user, team, 'jdi_line_limit', team.current)){   

        var new_lines = JSON.parse(JSON.stringify(lineSegments));

        var spline = this.state.splineInProgress;

        spline.splice(spline.length - 1, 1);

        new_lines = new_lines.concat(spline);

        this.setState({
          splineInProgress: []
        })

        this.generate(new_lines);
      }
    }

    const handleDragBoxStop = (el) => {
      if(tool === 'Pointer' && pattern.lineSegments.length <= canI(user, team, 'jdi_line_limit', team.current)){
        if(draggingSelection){
          var d = draggingSelection;

          if(d.w === undefined || d.h === undefined) return;

          var newCurrentLines = [];
          
          for(var i = 0; i < lineSegments.length; i++){
            var l = lineSegments[i];
            l.currentlyBoxed = false;

            var lx1 = x_scale(l.x1);
            var ly1 = y_scale(l.y1);
            var lx2 = x_scale(l.x2);
            var ly2 = y_scale(l.y2);

            if(!draggingSelection.strict){
              // top edge of box
              var intersection = getIntersection(d.x, d.y, d.x + d.w, d.y,  lx1, ly1, lx2, ly2);
              if(intersection){
                newCurrentLines.push(i);
                l.currentlyBoxed = true;
                continue;
              }

              // bottom edge of box
              intersection = getIntersection(d.x, d.y + d.h, d.x + d.w, d.y + d.h,  lx1, ly1, lx2, ly2);
              if(intersection){
                newCurrentLines.push(i);
                l.currentlyBoxed = true;
                continue;
              }

              // left edge of box
              intersection = getIntersection(d.x, d.y, d.x, d.y + d.h,  lx1, ly1, lx2, ly2);
              if(intersection){
                newCurrentLines.push(i);
                l.currentlyBoxed = true;
                continue;
              }

              // right edge of box
              intersection = getIntersection(d.x + d.w, d.y, d.x + d.w, d.y + d.h,  lx1, ly1, lx2, ly2);
              if(intersection){
                newCurrentLines.push(i);
                l.currentlyBoxed = true;
                continue;
              }
            }

            if(lx1 > d.x && lx1 < d.x + d.w && ly1 > d.y && ly1 < d.y + d.h && lx2 > d.x && lx2 < d.x + d.w && ly2 > d.y && ly2 < d.y + d.h){
              newCurrentLines.push(i);
              l.currentlyBoxed = true;
              continue;
            }
          }
           

          d3.select('#jdi-selection-drag')
            .attr('opacity', 0)
            ;

          d3.selectAll('.jdi-svg-line')
            .style('pointer-events', 'auto')
            ;
          draggingSelection = undefined;

          this.setState({
            currentLines: newCurrentLines
          }) 
          
          this.drawSVG();
        }
      }
    }

    const handleDragBoxUpdate = (el) => {
      if(tool === 'Pointer' && pattern.lineSegments.length <= canI(user, team, 'jdi_line_limit', team.current)){
        if(draggingSelection){
          var m = getCoordinates(d3.select(el), this.state.lineInProgress, tool);

          draggingSelection.strict = true;
          var dsw = x_scale(m[0]) - x_scale(draggingSelection.xog);
          var x = x_scale(draggingSelection.xog);
          if(dsw < 0){
            dsw *= -1;
            x = x_scale(m[0]);
            draggingSelection.strict = false;
          }

          var dsh = y_scale(m[1]) - y_scale(draggingSelection.yog);
          var y = y_scale(draggingSelection.yog);
          if(dsh < 0){
            dsh *= -1;
            y = y_scale(m[1]);
          }

          draggingSelection.x = x;
          draggingSelection.y = y;
          draggingSelection.w = dsw;
          draggingSelection.h = dsh;

          d3.select('#jdi-selection-drag')
            .attr('x', x)
            .attr('y', y)
            .attr('width', dsw)
            .attr('height', dsh)
            .attr('stroke-dasharray', draggingSelection.strict ? 'none' : '5,5')
            ;
        }
      }
    }

    const handleDragEndpointStop = (el) => {
      if(tool === 'Pointer' && pattern.lineSegments.length <= canI(user, team, 'jdi_line_limit', team.current)){
        if(draggingEndpoint){
          var m = getCoordinates(d3.select(el), draggingEndpoint.lineInProgress);
          
          lineSegments[draggingEndpoint.index]['x' + draggingEndpoint.which] = m[0];
          lineSegments[draggingEndpoint.index]['y' + draggingEndpoint.which] = m[1];
          
          draggingEndpoint = false;

          that.generate(lineSegments, draggingEndpoint.index);
          this.drawSVG();
        }
      }
    }

    const handleDragEndpointUpdate = (el) => {
      if(tool === 'Pointer' && pattern.lineSegments.length <= canI(user, team, 'jdi_line_limit', team.current)){
        if(draggingEndpoint){
          var m = getCoordinates(d3.select(el), draggingEndpoint.lineInProgress);
          d3.select('#jdi-line-' + draggingEndpoint.index)
            .attr('x' + draggingEndpoint.which, x_scale(m[0]))
            .attr('y' + draggingEndpoint.which, y_scale(m[1]))
            ;

          d3.select('#jdi-selection-handle-' + draggingEndpoint.index + '-' + draggingEndpoint.which)
            .attr('cx', x_scale(m[0]))
            .attr('cy', y_scale(m[1]))
            .style('pointer-events', 'none')
            ;   
        }
      }
    }

    const handleDeselectClick = () => {
      if(tool === 'Pointer'){
        // if(currentLines){
          // currentLines = [];
          this.setState({
            currentLines: []
          })
          // dispatch(pmUpdateFromHybrid({
          //   cacheID: cacheID,
          //   pattern: {
          //     currentLines: currentLines
          //   }
          // }))
          that.drawSVG();
        // }
      }
    }

    const handleDrawLineUpdate = (el) => {
      if((tool === 'Pen' || tool === 'Continuous Pen') && pattern.lineSegments.length < canI(user, team, 'jdi_line_limit', team.current)){
        if(this.state.midLine){
          var m = getCoordinates(d3.select(el), this.state.lineInProgress);

          d3.select('#line-in-progress')
            .attr('x2', function(d){ return x_scale(m[0]); })
            .attr('y2', function(d){ return y_scale(m[1]); })
            .attr('opacity', 1)
            .attr('class', function(d){
              if(!globalReducer.colors) return;
              if(pattern.rows.length === 0) return 'line_0';
              return 'line_' + (((pattern.rows[pattern.rows.length - 1].original_index + 1) * 3) % 11);
            })
            ;
        }
      } 
    }

    const handleDrawLineClick = (el) => {
      var lineInProgress = this.state.lineInProgress || {};
      var midLine = this.state.midLine;

      if(tool == 'Pen' && pattern.lineSegments.length < canI(user, team, 'jdi_line_limit', team.current)){
        var m = getCoordinates(d3.select(el), lineInProgress);

        if(midLine){
          lineInProgress.x2 = m[0];
          lineInProgress.y2 = m[1];
          midLine = false;
          addLine(lineInProgress);
          this.drawSVG();
        } else{
          lineInProgress.x1 = m[0];
          lineInProgress.y1 = m[1];
          midLine = true;
          
          d3.select('#line-in-progress')
            .attr('x1', function(d){ return x_scale(m[0]); })
            .attr('y1', function(d){ return y_scale(m[1]); })
            .attr('x2', function(d){ return x_scale(m[0]); })
            .attr('y2', function(d){ return y_scale(m[1]); })
            .attr('class', function(d){
              if(!globalReducer.colors) return;
              if(pattern.rows.length === 0) return 'line_0';
              return 'line_' + (((pattern.rows[pattern.rows.length - 1].original_index + 1) * 3) % 11);
            })
            ;
        }

        this.setState({
          lineInProgress: lineInProgress,
          midLine: midLine
        })
      } else if(tool == 'Continuous Pen'){
        var m = getCoordinates(d3.select(el), lineInProgress);

        if(midLine){
          lineInProgress.x2 = m[0];
          lineInProgress.y2 = m[1];
          // midLine = false;
          addLine(lineInProgress);
          this.drawSVG();

          lineInProgress.x1 = m[0];
          lineInProgress.y1 = m[1];
          d3.select('#line-in-progress')
            .attr('x1', function(d){ return x_scale(m[0]); })
            .attr('y1', function(d){ return y_scale(m[1]); })
            .attr('x2', function(d){ return x_scale(m[0]); })
            .attr('y2', function(d){ return y_scale(m[1]); })
            .attr('class', function(d){
              if(!globalReducer.colors) return;
              if(pattern.rows.length === 0) return 'line_0';
              return 'line_' + (((pattern.rows[pattern.rows.length - 1].original_index + 1) * 3) % 11);
            })
            ;

        } else{
          lineInProgress.x1 = m[0];
          lineInProgress.y1 = m[1];
          midLine = true;
          
          d3.select('#line-in-progress')
            .attr('x1', function(d){ return x_scale(m[0]); })
            .attr('y1', function(d){ return y_scale(m[1]); })
            .attr('x2', function(d){ return x_scale(m[0]); })
            .attr('y2', function(d){ return y_scale(m[1]); })
            .attr('class', function(d){
              if(!globalReducer.colors) return;
              if(pattern.rows.length === 0) return 'line_0';
              return 'line_' + (((pattern.rows[pattern.rows.length - 1].original_index + 1) * 3) % 11);
            })
            ;
        }

        this.setState({
          lineInProgress: lineInProgress,
          midLine: midLine
        })
      }

    }

    const handleCrosshairsShow = (el) => {
      d3.selectAll('.jdi-snap-ruler')
        .attr('opacity', .5)
        ;
    }

    const handleCrosshairsHide = (el) => {
      if(!this.state.midLine){
        d3.selectAll('.jdi-snap-ruler')
          .attr('opacity', 0)
          ;
        d3.select('#jdi-snap-circle')
          .attr('opacity', 0)
          ;
        d3.selectAll('.jdi-snap-ruler-label')
          .attr('opacity', 0)
          ;
      }
    }

    const handleCrosshairsUpdate = (el) => {
      if(tool == 'Pointer' || tool === 'Pen' || tool === 'Continuous Pen' || tool === 'Spline' || draggingEndpoint){
        var m = getCoordinates(d3.select(el), this.state.lineInProgress, tool);
        this.handleCrosshairsMove(m[0], m[1], m[2], m[3], m[4]);
      }
      if(tool === 'Circle'){
        var m;
        if(circleInProgress){
          m = getCoordinates(d3.select(el), {x1: circleInProgress.x, y1: circleInProgress.y}, tool);
        } else {
          m = getCoordinates(d3.select(el), this.state.lineInProgress, tool);
        }
        this.handleCrosshairsMove(m[0], m[1], m[2], m[3], m[4]); 
      }
    }

    const getCoordinates = (div, lineInProgress, tool) => {
      const snapThreshold = (10 / rectWidth) * jdiSettings.canvas_width;

      var mouse = d3.mouse(div.node());
      var mx = ((mouse[0] + rectWidth/2 - width/2) / rectWidth) * jdiSettings.canvas_width;
      var my = (1 - (mouse[1] + rectHeight/2 - height/2) / rectHeight) * jdiSettings.canvas_height;
      var closestX = 0;
      var closestY = 0;
      var minDistance = Infinity; 
      var distance;

      if(tool === 'Pointer' && !draggingEndpoint){
        return [mx, my];
      }
      if(tool === 'Trim'){
        return [mx, my];
      }
      // console.log('snap logic', tool);

      // snap lines
      if(jdiSettings.line_snap_global){
        for(var i = 0; i < lineSegments.length; i++){
          var l = lineSegments[i];

          // endpoint 1
          if(jdiSettings.line_snap_endpoints){
            distance = getDistance(mx, my, l.x1, l.y1);
            if(distance < minDistance){
              minDistance = distance;
              closestX = l.x1;
              closestY = l.y1;
            }

            // endpoint 2
            distance = getDistance(mx, my, l.x2, l.y2);
            if(distance < minDistance){
              minDistance = distance;
              closestX = l.x2;
              closestY = l.y2;
            }
          }

          // midpoint
          if(jdiSettings.line_snap_midpoints){
            distance = getDistance(mx, my, (l.x1 + l.x2) / 2, (l.y1 + l.y2) / 2);
            if(distance < minDistance){
              minDistance = distance;
              closestX = (l.x1 + l.x2) / 2;
              closestY = (l.y1 + l.y2) / 2;
            }
          }

          // intersections
          if(jdiSettings.line_snap_intersections){
            for(var j = i + 1; j < lineSegments.length; j++){
              var l_test = lineSegments[j];
              var intersect = getIntersection(l.x1,l.y1, l.x2,l.y2, l_test.x1,l_test.y1, l_test.x2,l_test.y2);
              if(intersect){
                distance = getDistance(mx, my, intersect.x, intersect.y);
                if(distance < minDistance){
                  minDistance = distance;
                  closestX = intersect.x;
                  closestY = intersect.y;
                }
              }
            }
          }
        }

        // corners
        if(true){
          distance = getDistance(mx, my, 0, 0);
          if(distance < minDistance){
            minDistance = distance;
            closestX = 0;
            closestY = 0;
          }

          distance = getDistance(mx, my, jdiSettings.canvas_width/2, 0);
          if(distance < minDistance){
            minDistance = distance;
            closestX = jdiSettings.canvas_width/2;
            closestY = 0;
          }

          distance = getDistance(mx, my, jdiSettings.canvas_width, 0);
          if(distance < minDistance){
            minDistance = distance;
            closestX = jdiSettings.canvas_width;
            closestY = 0;
          }

          distance = getDistance(mx, my, 0, jdiSettings.canvas_height);
          if(distance < minDistance){
            minDistance = distance;
            closestX = 0;
            closestY = jdiSettings.canvas_height;
          }

          distance = getDistance(mx, my, 0, jdiSettings.canvas_height/2);
          if(distance < minDistance){
            minDistance = distance;
            closestX = 0;
            closestY = jdiSettings.canvas_height/2;
          }

          distance = getDistance(mx, my, jdiSettings.canvas_width, jdiSettings.canvas_height);
          if(distance < minDistance){
            minDistance = distance;
            closestX = jdiSettings.canvas_width;
            closestY = jdiSettings.canvas_height;
          }

          distance = getDistance(mx, my, jdiSettings.canvas_width, jdiSettings.canvas_height/2);
          if(distance < minDistance){
            minDistance = distance;
            closestX = jdiSettings.canvas_width;
            closestY = jdiSettings.canvas_height/2;
          }


          distance = getDistance(mx, my, jdiSettings.canvas_width/2, jdiSettings.canvas_height);
          if(distance < minDistance){
            minDistance = distance;
            closestX = jdiSettings.canvas_width/2;
            closestY = jdiSettings.canvas_height;
          }
        }
        


        //ortho
        var orthoSnap = false;
        if(jdiSettings.ortho){
          if(lineInProgress){
            if(Math.abs(mx - lineInProgress.x1) < snapThreshold){
              mx = lineInProgress.x1;
              orthoSnap = true;
            }
            if(Math.abs(my - lineInProgress.y1) < snapThreshold){
              my = lineInProgress.y1;
              orthoSnap = true;
            }
          }
        }

        // aligned snap
        if(jdiSettings.line_snap_aligned){
          var alignedSnap;
          var alignedSnapX;
          var alignedSnapY;
          if(true){
            for(var i in lineSegments){
              if(Math.abs(my - lineSegments[i].y1) < snapThreshold / 2){
                my = lineSegments[i].y1;
                alignedSnap = true;
                alignedSnapY = true;
              }
              if(Math.abs(my - lineSegments[i].y2) < snapThreshold / 2){
                my = lineSegments[i].y2;
                alignedSnap = true;
                alignedSnapY = true;
              }
            }

            for(var i in lineSegments){
              if(Math.abs(mx - lineSegments[i].x1) < snapThreshold / 2){
                mx = lineSegments[i].x1;
                alignedSnap = true;
                alignedSnapX = true;
              }
              if(Math.abs(mx - lineSegments[i].x2) < snapThreshold / 2){
                mx = lineSegments[i].x2;
                alignedSnap = true;
                alignedSnapX = true;
              }
            }
          }
        }
      }

     
      // edges
      var edgeSnap;
      if(true){
        if(mx < 0){ 
          mx = 0;
          edgeSnap = true;
        }
        if(mx > jdiSettings.canvas_width){ 
          mx = jdiSettings.canvas_width;
          edgeSnap = true;
        }
        if(my < 0){ 
          my = 0;
          edgeSnap = true;
        }
        if(my > jdiSettings.canvas_height){ 
          my = jdiSettings.canvas_height;
          edgeSnap = true;
        }
      }

       // grid
      if(jdiSettings.grid_snap_global){

        var gx = Math.round(mx / jdiSettings.grid_snap_size) * jdiSettings.grid_snap_size;
        var gy = Math.round(my / jdiSettings.grid_snap_size) * jdiSettings.grid_snap_size;

        distance = getDistance(mx, my, gx, gy);
        if(distance < minDistance){
          minDistance = distance;
          closestX = gx;
          closestY = gy;
        }
      }
      
      // snap found!
      if(minDistance < snapThreshold || patternManager.cache[cacheID].jdiSettings.grid_snap_global){
        return [closestX, closestY, true];
      }
      // console.log(edgeSnap,orthoSnap,alignedSnap)
      
      return [mx, my, edgeSnap || orthoSnap || alignedSnap, alignedSnapX, alignedSnapY];
    }

    const getDistance = (x1, y1, x2, y2) => {
      return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    }

   function getIntersection(x1, y1, x2, y2, x3, y3, x4, y4, strict) {

      // Check if none of the lines are of length 0
      if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
        return false
      }

      var denominator = ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1))

      // Lines are parallel
      if (denominator === 0) {
        return false
      }

      let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator
      let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator

      // is the intersection along the segments
      if(strict){
        if (ua <= 0 || ua >= 1 || ub <= 0 || ub >= 1) {
          return false
        }
      } else {
        if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
          return false
        }
      }

      // Return a object with the x and y coordinates of the intersection
      let x = x1 + ua * (x2 - x1)
      let y = y1 + ua * (y2 - y1)

      return {x, y}
    }

    const addLine = (lip) => {
      var new_lines = JSON.parse(JSON.stringify(lineSegments));
      new_lines.push(JSON.parse(JSON.stringify(lip)))
      this.generate(new_lines);
    }
  }

  handleCrosshairsMove(x, y, snapping, alignedX, alignedY){
    const { dispatch, patternManager, cacheID, tool, pattern } = this.props;  

    var el = document.getElementById('jdi-svg');
    var positionInfo = el.getBoundingClientRect();
    var width = positionInfo.width;
    var height = positionInfo.height;

    var padding = 20;
    var paneRatio = (width - padding * 2) / (height - padding * 2);
    var drawRatio = patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width / patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height;

    if(paneRatio > drawRatio){
      var rectHeight = height - padding * 2;
      var rectWidth = rectHeight * drawRatio;
    } else {
      var rectWidth = width - padding * 2;
      var rectHeight = rectWidth / drawRatio;
    }

    var x_scale = d3.scaleLinear()
      .domain([0, patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width])
      .range([width/2 - rectWidth/2, width/2 + rectWidth/2])
      .clamp(true)
      ;

    var y_scale = d3.scaleLinear()
      .domain([patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height, 0])
      .range([height/2 - rectHeight/2, height/2 + rectHeight/2])
      .clamp(true)
      ;

    d3.selectAll('.jdi-snap-ruler')
      .attr('class', 'jdi-snap-ruler stroke-secondary')
      ;

    if(snapping && !alignedX && !alignedY){
      d3.selectAll('.jdi-snap-ruler')
        .attr('class', 'jdi-snap-ruler stroke-success')
        ;
    }

    if(alignedY){
      d3.select('#jdi-snap-horizontal-ruler')
        .attr('class', 'jdi-snap-ruler stroke-success')
        ;
    }
    if(alignedX){
      d3.select('#jdi-snap-vertical-ruler')
        .attr('class', 'jdi-snap-ruler stroke-success')
        ;
    }
      // d3.select('#jdi-snap-circle')
      //   .attr('cx', x_scale(x))
      //   .attr('cy', y_scale(y))
      //   .attr('opacity', 1)
      //   ;
    // } else {
      
      // d3.select('#jdi-snap-circle')
      //   .attr('opacity', 0)
      //   ;
    // }

    d3.select('#jdi-snap-vertical-ruler')
      .attr('x1', x_scale(x))
      .attr('y1', y_scale(0))
      .attr('x2', x_scale(x))
      .attr('y2', y_scale(patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height))
      .attr('opacity', .5)
      ;

    d3.select('#jdi-snap-vertical-ruler-label')
      .text(()=>{
        var t = roundValue(x, 4);
        if(t > patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width) return patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width;
        if(t < 0) return 0;
        return t;
      })
      .attr('x', () => {
        if(x_scale(x) > x_scale(patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width) - 50){
          return x_scale(x) - 5;
        }
        return x_scale(x) + 5;
      })
      .attr('text-anchor', () => {
        if(x_scale(x) > x_scale(patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width) - 50){
          return 'end';
        }
        return 'start';
      })
      .attr('y', y_scale(0) - 5)
      .attr('opacity', 1)
      ;

    d3.select('#jdi-snap-horizontal-ruler')
      .attr('x1', x_scale(0))
      .attr('y1', y_scale(y))
      .attr('x2', x_scale(patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width))
      .attr('y2', y_scale(y))
      .attr('opacity', .5)
      ;

    d3.select('#jdi-snap-horizontal-ruler-label')
      .text(()=>{
        var t = roundValue(y, 4);
        if(t > patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height) return patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height;
        if(t < 0) return 0;
        return t;
      })
      .attr('x', x_scale(0) + 5)
      .attr('y', () => {
        if(y_scale(y) > y_scale(0) - 25){
          return y_scale(y) - 5;
        }
        return y_scale(y) + 15;
      })
      .attr('opacity', 1)
      ;
  }

  clipOutOfBoundsSegment(line){
    const { patternManager } = this.props;

    var tl_x = 0;
    var tl_y = patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height;

    var tr_x = patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width;
    var tr_y = patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height;

    var bl_x = 0;
    var bl_y = 0;

    var br_x = patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width;
    var br_y = 0;

    var starts_inside = false;
    var ends_inside = false;
    if(line.x1 >= 0 && line.x1 <= patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width && line.y1 >= 0 && line.y1 <= patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height){
      starts_inside = true;
    }
    if(line.x2 >= 0 && line.x2 <= patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width && line.y2 >= 0 && line.y2 <= patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height){
      ends_inside = true;
    }

    if(!starts_inside && !ends_inside) return;

    if(starts_inside && ends_inside) return line;

    var sides = [
      {x1: tl_x, y1: tl_y, x2: tr_x, y2: tr_y},
      {x1: tl_x, y1: tl_y, x2: bl_x, y2: bl_y},
      {x1: br_x, y1: br_y, x2: bl_x, y2: bl_y},
      {x1: br_x, y1: br_y, x2: tr_x, y2: tr_y},
    ]

    for(var i in sides){
      var intersection = checkLineIntersection(line, sides[i]);
      if(intersection.onLine2 && intersection.onLine1){
        // console.log(line, intersection);
        if(starts_inside){
          line.x2 = intersection.x;
          line.y2 = intersection.y;
        }
        if(ends_inside){
          line.x1 = intersection.x;
          line.y1 = intersection.y;
        }
        break;
      }
    }

    let floatingTrim = .00000001;
    if(Math.abs(line.x1 - line.x2) < floatingTrim && Math.abs(line.y1 - line.y2) < floatingTrim){
      return; 
    }

    return line;
  }


  generate(lineSegments, currentLine, recolor){
    const { dispatch, patternManager, pattern, cacheID, tool } = this.props;  
   
    var lostRows = 0;
    var rows = [];
    
    var currentLines = this.state.currentLines;
    var new_lines = JSON.parse(JSON.stringify(lineSegments));

    for(var i = 0; i < new_lines.length; i++){
      var l = new_lines[i];

      if(tool === 'Circle'){
        l = this.clipOutOfBoundsSegment(l);

        if(!l){
          new_lines.splice(i, 1);
          i--;
          continue;
        }

        if(l.x1 == l.x2 && l.y1 == l.y2){
          new_lines.splice(i, 1);
          i--;
          continue; 
        }
      }
      
      var c = convertLineToRow(patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width, patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height, l.x1, l.y1, l.x2, l.y2, pattern.format, pattern.type, pattern.units, patternManager.cache[patternManager.current_pattern].jdiSettings.autofix);

      if(c){
        c.original_index = rows.length;
        rows.push(c);
      } else {
        lostRows++;
      }
    }

    for(var i in rows){
      for(var j in pattern.rows){
        if(rows[i].cells.toString() === pattern.rows[j].cells.toString()){
          if(!recolor){
            rows[i].original_index = pattern.rows[j].original_index;
          }
          rows[i].bold = pattern.rows[j].bold;
          rows[i].greyscale = pattern.rows[j].greyscale;
          rows[i].invisible = pattern.rows[j].invisible;
        }
      }
    }

    if(rows.length > 1){
      if(rows[rows.length - 1].original_index === rows[rows.length - 2].original_index){
        rows[rows.length - 1].original_index++;
      }
    }

    dispatch(pmUpdateFromHybrid({
      pattern: {
        rows: rows,
        width: patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_width,
        height: patternManager.cache[patternManager.current_pattern].jdiSettings.canvas_height,
        lineSegments: new_lines
      },
      cacheID: cacheID,
      regenText: true
    }));
    // console.log("LOST", lostRows);
    this.setState({
      lostRows: lostRows,
      currentLines: currentLines
    })
  }

  keyListener(e){
    const { dispatch, patternManager, cacheID, tool, pattern } = this.props;  

    var lineSegments = this.state.lineSegments;
    
    // delete
    if(e.keyCode == 8 || e.keyCode == 46){
      if(tool === 'Pointer'){
        if(this.state.currentLines){

          var new_ls = JSON.parse(JSON.stringify(lineSegments));
           
          for(var i in this.state.currentLines){
            new_ls.splice(this.state.currentLines[i] - i, 1);  
          }
          this.setState({
            currentLines: []
          })
          this.generate(new_ls);
        }
      }
    }

    // escape
    if(e.keyCode === 27){
      this.setState({
        currentKeyboardInputs: "",
        coordinateInFocus: "x",
        lineInProgress: {},
        currentLines: [],
        midLine: false
      })
    }

    // if(e.keyCode === 8){
    //   console.log('delete');
    //   if(tool === 'Pen'){
    //     var currentKeyboardInputs = this.state.currentKeyboardInputs || "";
    //     if(currentKeyboardInputs){
    //       currentKeyboardInputs = currentKeyboardInputs.substring(0, currentKeyboardInputs.length - 1);
    //       this.setState({
    //         currentKeyboardInputs: currentKeyboardInputs
    //       })
    //       e.preventDefault();
    //     }
    //   }
    // }

    if((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 190 || e.keyCode === 189) { 
      if(tool === 'Pen' || tool === 'Continuous Pen'){ 
        var number;

        if(e.keyCode <= 57){
          number = e.keyCode - 48;
        } else if(e.keyCode <= 105){
          number = e.keyCode - 96;
        }

        var currentKeyboardInputs = this.state.currentKeyboardInputs || "";

        if(e.keyCode === 190){
          if(currentKeyboardInputs.indexOf(".") === -1){
            currentKeyboardInputs += ".";
          }
        } else if(e.keyCode === 189){
          if(currentKeyboardInputs === ""){
            currentKeyboardInputs += "-";
          }
        } else if(number !== undefined){
          currentKeyboardInputs += number.toString();
        }

        this.setState({
          currentKeyboardInputs: currentKeyboardInputs
        })

        setTimeout(()=>{
          if(this.state.coordinateInFocus === 'x'){
            if(this.state.midLine){
              this.handleCrosshairsMove(parseFloat(currentKeyboardInputs), this.state.lineInProgress.y1);  
            } else {
              this.handleCrosshairsMove(parseFloat(currentKeyboardInputs), 0);  
            }
          } else {
            if(this.state.midLine){
              this.handleCrosshairsMove(this.state.lineInProgress.x2, parseFloat(currentKeyboardInputs) + this.state.lineInProgress.y1);
            } else {
              this.handleCrosshairsMove(this.state.lineInProgress.x1, parseFloat(currentKeyboardInputs));
            }
          }
        }, 10);

        // console.log('NUMBER', e.keyCode, number, currentKeyboardInputs);
      }
    }

    if(e.keyCode == 188 || e.keyCode === 13){
      // console.log('COMMA or ENTER');
      if(tool === 'Pen' || tool === 'Continuous Pen'){ 

        // gotta be something that was typed
        if(this.state.currentKeyboardInputs){
          var k = this.state.coordinateInFocus || "x";
          if(k === "x"){

            var lineInProgress = this.state.lineInProgress || {};
            // set the line in place
            if(!this.state.midLine){
              lineInProgress.x1 = parseFloat(this.state.currentKeyboardInputs);
            } else {
              lineInProgress.x2 = parseFloat(this.state.currentKeyboardInputs) + lineInProgress.x1;
            }

            this.setState({
              coordinateInFocus: "y",
              lineInProgress: lineInProgress,
              currentKeyboardInputs: ""
            })

            setTimeout(()=>{
              if(this.state.coordinateInFocus === 'y'){
                if(this.state.midLine){
                  this.handleCrosshairsMove(lineInProgress.x1 + lineInProgress.x2, this.state.lineInProgress.y1);  
                } else {
                  this.handleCrosshairsMove(lineInProgress.x1, 0);  
                }
              } else {
                if(this.state.midLine){
                  this.handleCrosshairsMove(lineInProgress.x1 + lineInProgress.x2, parseFloat(this.state.currentKeyboardInputs) + lineInProgress.y1);
                } else {
                  this.handleCrosshairsMove(lineInProgress.x1, parseFloat(this.state.currentKeyboardInputs));
                }
              }
            }, 10);
          } else {
            
            var lineInProgress = this.state.lineInProgress || {};
            // set the line in place and clear keyboard coordinates
            if(!this.state.midLine){
              lineInProgress.y1 = parseFloat(this.state.currentKeyboardInputs);

              this.setState({
                coordinateInFocus: "x",
                lineInProgress: lineInProgress,
                midLine: true,
                currentKeyboardInputs: ""
              })

              setTimeout(()=>{
                if(this.state.coordinateInFocus === 'y'){
                  this.handleCrosshairsMove(parseFloat(this.state.currentKeyboardInputs), 0);  
                } else {
                  this.handleCrosshairsMove(this.state.lineInProgress.x1, lineInProgress.y1);
                }
              }, 10);

            } else {
              lineInProgress.y2 = parseFloat(this.state.currentKeyboardInputs) + lineInProgress.y1;

              // console.log('time to make line', lineInProgress);

              this.state.lineSegments.push(lineInProgress);
              this.generate(pattern.lineSegments);

              this.setState({
                coordinateInFocus: "x",
                midLine: false,
                lineInProgress: {},
                currentKeyboardInputs: ""
              })
            }
          }
        }
      }
    }
    this.drawSVG();
  }

  componentWillUnmount(){
    document.getElementById('jdi').removeEventListener("keydown", this.keyListener, false);
  }

  componentDidMount(){
    document.getElementById('jdi').addEventListener("keydown", this.keyListener, false);

    setTimeout(this.drawSVG, 100);
    window.addEventListener('resize', () =>{
      clearTimeout(drawJDITimeout);
      drawJDITimeout = setTimeout(this.drawSVG, 200);
    });
  }

  componentWillReceiveProps(newprops){
    // console.log("JDI NEW PROPS", newprops.pattern.jdiSettings.canvas_width, newprops.pattern.jdiSettings.canvas_height, this.props.pattern.jdiSettings.canvas_width, this.props.pattern.jdiSettings.canvas_height);

    this.setState({
      lineSegments: newprops.pattern.lineSegments || []
    });

    if(newprops.tool !== 'Pointer'){
      this.setState({
        currentLines: []
      })
    }

    if(newprops.tool !== this.props.tool){
      this.setState({
        lineInProgress: {},
        midLine: false
      })
    }

    if(newprops.pattern.lineSegments.length === 0){
      this.setState({
        lostRows: 0
      })
    }

    if(newprops.pattern.jdiSettings.canvas_width !== this.props.pattern.jdiSettings.canvas_width || newprops.pattern.jdiSettings.canvas_height !== this.props.pattern.jdiSettings.canvas_height){
      setTimeout(()=>{
        this.generate(this.state.lineSegments);  
      }, 100)
    }

    clearTimeout(drawJDITimeout);

    // console.log("props fire");
    drawJDITimeout = setTimeout(this.drawSVG, 100);
  }

  render(){
    const { patternManager, cacheID, dispatch } = this.props; 

    let jdiSettings = {};

    if(patternManager.cache[cacheID]){
      jdiSettings = patternManager.cache[cacheID].jdiSettings;
    }

    return (
      <div className="jdi" id="jdi" tabIndex="0">
        {
          !this.props.demo &&
          <div className="jdi-field-row">
            
            <nobr className="jdi-field-pair">
              <span className="jdi-field-label">
                <span
                  className="has-tooltip"
                  onMouseEnter={(e)=>{ 
                    dispatch(showTooltip({
                      e: e,
                      position: 'bottom', 
                      lag: 100,
                      nobr: false,
                      content: <div style={{width: 200}}>
                        <span className="text-700">Auto Fix</span> will attempt to shift lines to avoid errors caused by Revit & AutoCAD import limitations. If any lines cannot be converted to fit within these limitations, a warning will be shown.
                      </div>
                    }))
                  }} 
                  onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                  >
                  <i className="fal fa-question-circle text-grey-primary"/>
                </span>&nbsp;
                Auto fix: 
              </span>

              <Checkbox switch={true} value={jdiSettings.autofix} onToggle={(e)=>{ 
                let newSettings = JSON.parse(JSON.stringify(jdiSettings));
                newSettings.autofix = !newSettings.autofix;

                dispatch(pmUpdateFromHybrid({
                  cacheID: patternManager.current_pattern,
                  pattern: {
                    jdiSettings: newSettings
                  }
                }))
                setTimeout(()=>{
                  this.generate(this.state.lineSegments);  
                })
              }}/>
            </nobr>
            

            <nobr className="jdi-field-pair">
              <span className="jdi-field-label">ORTHO: </span>
              <Checkbox switch={true} value={jdiSettings.ortho} onToggle={(e)=>{ 
                let newSettings = JSON.parse(JSON.stringify(jdiSettings));
                newSettings.ortho = !newSettings.ortho;

                dispatch(pmUpdateFromHybrid({
                  cacheID: patternManager.current_pattern,
                  pattern: {
                    jdiSettings: newSettings
                  }
                }))
              }}/>
            </nobr>

            <nobr className="jdi-field-pair">
              <span className="jdi-field-label">GRIDSNAP: </span>
              <Checkbox switch={true} value={jdiSettings.grid_snap_global} onToggle={(e)=>{ 
                let newSettings = JSON.parse(JSON.stringify(jdiSettings));
                newSettings.grid_snap_global = !newSettings.grid_snap_global;

                dispatch(pmUpdateFromHybrid({
                  cacheID: patternManager.current_pattern,
                  pattern: {
                    jdiSettings: newSettings
                  }
                }))
              }}/>
            </nobr>

            <nobr className="jdi-field-pair">
              <span className="jdi-field-label">LINESNAP: </span>
              <Checkbox switch={true} value={jdiSettings.line_snap_global} onToggle={(e)=>{ 
                let newSettings = JSON.parse(JSON.stringify(jdiSettings));
                newSettings.line_snap_global = !newSettings.line_snap_global;

                dispatch(pmUpdateFromHybrid({
                  cacheID: patternManager.current_pattern,
                  pattern: {
                    jdiSettings: newSettings
                  }
                }))
              }}/>
            </nobr>
            <span className="jdi-field-divider">|</span>
            <span 
              className="jdi-settings-btn"
              onMouseEnter={(e)=>{ 
                dispatch(showTooltip({
                  lag: 150, 
                  e: e, 
                  position: 'top', 
                  content: <span>Advanced Settings</span>
                })) 
              }} 
              onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
              onClick={(e) => { 
                // if(canI(user, team, 'jdi_settings', team.current)){
                  dispatch(setJDISettingsModalOpen(true));
                // }
              }}>
              <i className="fad fa-cog"/>
            </span>

          </div>

        }
        <div className="jdi-svg-wrapper">
          <svg className="jdi-svg" id="jdi-svg"></svg>
        </div>
      </div>
    )
  }
}

JustDrawIt = reduxForm({
  // a unique name for the form
  form: 'JustDrawIt',
  enableReinitialize: true,
  destroyOnUnmount: false
})(JustDrawIt)


JustDrawIt = connect((state, ownProps) => {
  const { patternManager, globalReducer, user, team } = state;

  var initialValues = {
    // width: ownProps.pattern.width || 12,
    // height: ownProps.pattern.height || 12
  }


  return {
    patternManager,
    globalReducer,
    initialValues,
    state,
    user,
    team
  }
})(JustDrawIt);


export default JustDrawIt;


// WEBPACK FOOTER //
// ./src/components/JustDrawIt/JustDrawIt.js